import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';

import { RegisterMode, ClearCardRegistered } from '../../../actions/terminal';

const ErrorPopup = ({ onClose, errorMessage }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const [{ closePopup }] = useContext(PopupContext);

  const registerPopupForDms = () => {
    onClose?.() || closePopup();
    dispatch(RegisterMode(false));
    dispatch(ClearCardRegistered());
  };

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Oops')}</h3>
      <div className="popup-main-content">
        <i className="global-icon icon-error-rejection error-icon-cont popup-main-icon" />
        <p className="text-center">{Array.isArray(errorMessage) ? t(...errorMessage) : t(errorMessage)}</p>
      </div>
      <button
        type="button"
        className="popup-confirm-button"
        onClick={registerPopupForDms}
      >
        {t('Ok')}
      </button>
    </div>
  );
};

export default ErrorPopup;
